import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, watch } from "vue";
import { useRouter } from "vue-router";
import { WOW } from "wowjs";
import HomeApi from "./api/homeApi";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter();

let wow = null;

watch(
  () => router.currentRoute.value,
  (to, from) => {
    wow = new WOW();
    wow.init();
  }
);

onMounted(async () => {
  await HomeApi.addHomeBrower();
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})